import { useEffect, useState } from 'react';
import phoneNumberService from 'src/services/phoneNumberService';

// AUTO-WA-39: the connected WhatsApp number (name, phone, messaging tier).
export default function useConnectedNumber(phoneNumberId) {
  const [number, setNumber] = useState(null);
  useEffect(() => {
    let active = true;
    setNumber(null);
    if (!phoneNumberId) return undefined;
    phoneNumberService.show(phoneNumberId)
      .then((response) => { if (active) setNumber(response?.data?.data || null); })
      .catch(() => { if (active) setNumber(null); });
    return () => { active = false; };
  }, [phoneNumberId]);
  return number;
}
